import {createContext, useContext, type Context} from 'react';
import type {ConversationBuilderState, ConversationDispatch} from './reducer';


type ChatbotContext = {
  state: ConversationBuilderState;
  dispatch: ConversationDispatch;
};

// @ts-expect-error - TS2322 - Type 'Context<{}>' is not assignable to type 'Context<ChatbotContext>'.
export const ChatbotStateContext: Context<ChatbotContext> = createContext({});

export function useChatbotStateContext(): ChatbotContext {
  const chatbotContext = useContext(ChatbotStateContext);
  if (!chatbotContext) {
    throw new Error(
      'useChatbotStateContext hook is not used inside a chatbot state tree',
    );
  }
  return chatbotContext;
}
